export default __webpack_public_path__ + "static/media/genuine-tape.e0372f8d.png";